import React, { useState, useMemo } from 'react';
import { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { MdArrowDropDown } from 'react-icons/md';
import { HeaderDropdown } from '@/components';

import { langs as LangsConfig } from '@/locale/config';
import styles from './Langs.module.less';

export const Langs = () => {
  const { i18n } = useTranslation();

  const [langsText, setLangsText] = useState(localStorage.getItem('langs') || 'en-US');

  const items: MenuProps['items'] = LangsConfig.map((items) => {
    return {
      label: (
        <div>
          <img src={items.icon} />
          {items.label}
        </div>
      ),
      key: items.key,
    };
  });

  const onClick: MenuProps['onClick'] = ({ key }) => {
    i18n.changeLanguage(LangsConfig.find((items) => items.key == key)?.abbreviationKey);
    localStorage.setItem('langs', key);
    setLangsText(key);
  };

  const getLangs = useMemo(() => {
    const data = LangsConfig.find((items) => items.key == langsText);
    return (
      <div className={styles.langsNav}>
        <img src={data?.icon} style={{ marginRight: 5 }} /> {data?.label}{' '}
        <span className="material-symbols-rounded">arrow_drop_down</span>
      </div>
    );
  }, [langsText]);

  return <HeaderDropdown menu={{ items, onClick }}>{getLangs}</HeaderDropdown>;
};
